// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HK-z","modalContent":"IK-z","header":"JK-z","close":"KK-z"};